import FJConfig from '../FJConfig';
/**
 * uniqueKey: 组件id（唯一）
 * name: 本地化显示
 * value: 模型ID
 * img: UI img
 * buryName: 埋点名（不用了，统一传模型ID）
 * isPro: 是否为pro模型（有钻石标志/4积分）
 * isExpensive: 是否为昂贵模型（没有钻石标志/4积分）
 * isNew: 是否为新模型（有新标志）
 */

export const STYLE_LIST = [
    {
        categoryName: 'hot',
        list: [
            {
                uniqueKey: 'hot-ghibli-2',
                name: 'ghibli-1',
                value: 'ghibli-2',
                img: 'ghibli-4.png',
                buryName: 'Ghibli',
            },

            {
                uniqueKey: 'hot-felt',
                name: 'felt',
                value: 'felt',
                img: 'felt.png',
                buryName: 'Felt',
            },
            {
                uniqueKey: 'hot-pixel-art',
                name: 'pixel-art',
                value: 'pixel-art',
                img: 'pixel-art.png',
                buryName: 'Pixel Art',
                isPro: true,
            },
            {
                uniqueKey: 'hot-anime-to-real',
                name: 'anime-to-real',
                value: 'anime-to-real',
                img: 'anime-to-real.png',
                buryName: 'Anime to Real',
                isPro: true,
            },
            {
                uniqueKey: 'hot-line-drawing',
                name: 'line-drawing',
                value: 'line-drawing',
                img: 'line-drawing.png',
                buryName: 'Line Drawing',
                isPro: true,
            },
            {
                uniqueKey: 'hot-3d-polaroid',
                name: '3d-polaroid',
                value: '3d-polaroid',
                img: '3d-polaroid.png',
                buryName: '3D Polaroid',
                isPro: true,
            },

            {
                uniqueKey: 'hot-b&w-sketch',
                name: 'b&w-sketch',
                value: 'b&w-sketch',
                img: 'b&w-sketch.png',
                buryName: 'B&W Sketch',
                isPro: true,
            },

            {
                uniqueKey: 'hot-verdant-realism',
                name: 'verdant-realism',
                value: 'verdant-realism',
                img: 'verdant-realism.png',
                buryName: 'Realism',
            },
            {
                uniqueKey: 'hot-purple-american-comic',
                name: 'purple-american-comic',
                value: 'purple-american-comic',
                img: 'purple-american-comic.png',
                buryName: 'Purple Comic',
            },

            {
                uniqueKey: 'hot-3d-cartoon-1',
                name: '3d-cartoon-1',
                value: '3d-cartoon-1',
                img: '3d-cartoon-1.png',
                buryName: '3D Cartoon 1',
                isPro: true,
            },
            {
                uniqueKey: 'hot-watercolor-1',
                name: 'watercolor-1',
                value: 'watercolor',
                img: 'watercolor.png',
                buryName: 'Watercolor 1',
                isPro: true,
            },
            {
                uniqueKey: 'hot-3d-emoji',
                name: '3d-emoji',
                value: '3d-emoji',
                img: '3d-emoji.png',
                buryName: '3D Emoji',
                isPro: true,
            },
        ],
    },
    {
        categoryName: 'anime',
        list: [
            {
                uniqueKey: 'anime-green-art',
                name: 'green-art',
                value: 'green-art',
                img: 'green-art.png',
                buryName: 'Green Art',
            },
            {
                uniqueKey: 'anime-purple-american-comic',
                name: 'purple-american-comic',
                value: 'purple-american-comic',
                img: 'purple-american-comic.png',
                buryName: 'Purple Comic',
            },
            {
                uniqueKey: 'anime-ghibli-2',
                name: 'ghibli-1',
                value: 'ghibli-2',
                img: 'ghibli-4.png',
                buryName: 'Ghibli',
            },

            {
                uniqueKey: 'hot-ghibli-1',
                name: 'ghibli-2',
                value: 'ghibli-1',
                img: 'ghibli-1.png',
                buryName: 'Ghibli02',
            },

            {
                uniqueKey: 'anime-felt',
                name: 'felt',
                value: 'felt',
                img: 'felt.png',
                buryName: 'Felt',
            },
            {
                uniqueKey: 'anime-muppet',
                name: 'muppet',
                value: 'muppet',
                img: 'muppet.png',
                buryName: 'Muppet',
                isPro: true,
            },
            {
                uniqueKey: 'anime-crochet-doll',
                name: 'crochet-doll',
                value: 'crochet-doll',
                img: 'crochet-doll.png',
                buryName: 'Crochet Doll',
                isPro: true,
            },
            {
                uniqueKey: 'anime-sitcom-comic',
                name: 'sitcom-comic',
                value: 'sitcom-comic',
                img: 'sitcom-comic.png',
                buryName: 'Sitcom Comic',
                isPro: true,
            },
            {
                uniqueKey: 'anime-chibi',
                name: 'chibi',
                value: 'chibi',
                img: 'chibi.png',
                buryName: 'Chibi',
                isPro: true,
            },
            {
                uniqueKey: 'anime-caricature-1',
                name: 'caricature-1',
                value: 'caricature',
                img: 'caricature-1.png',
                buryName: 'Caricature 1',
                isPro: true,
            },
            {
                uniqueKey: 'anime-caricature-2',
                name: 'caricature-2',
                value: 'caricature-2',
                img: 'caricature-2.png',
                buryName: 'Caricature 2',
                isPro: true,
            },
            {
                uniqueKey: 'anime-anime-to-real',
                name: 'anime-to-real',
                value: 'anime-to-real',
                img: 'anime-to-real.png',
                buryName: 'Anime to Real',
                isPro: true,
            },
            {
                uniqueKey: 'anime-vintage-2d-illustration',
                name: 'vintage-2d-illustration',
                value: 'vintage-2d-illustration',
                img: 'vintage-2d-illustration.png',
                buryName: 'Vintage 2D',
            },
            {
                uniqueKey: 'anime-claymation',
                name: 'claymation-1',
                value: 'claymation',
                img: 'claymation.png',
                buryName: 'Claymation 1',
            },
            {
                uniqueKey: 'anime-claymation-2',
                name: 'claymation-2',
                value: 'claymation-2',
                img: 'claymation-2.png',
                buryName: 'Claymation 2',
                isPro: true,
            },
            {
                uniqueKey: 'anime-2d-vector-art',
                name: '2d-vector-art',
                value: '2d-vector-art',
                img: '2d-vector-art.png',
                buryName: '2D Vector',
            },
            {
                uniqueKey: 'anime-vector-illustration',
                name: 'vector-illustration',
                value: 'vector-illustration',
                img: 'vector-illustration.png',
                buryName: 'Vector',
            },
            {
                uniqueKey: 'anime-retro-anime',
                name: 'retro-anime',
                value: 'retro-anime',
                img: 'retro-anime.png',
                buryName: 'Retro Anime',
            },
            {
                uniqueKey: 'anime-enchanted-comic-fantasy',
                name: 'enchanted-comic-fantasy',
                value: 'enchanted-comic-fantasy',
                img: 'enchanted-comic-fantasy.png',
                buryName: 'Comic Fantasy',
            },
            {
                uniqueKey: 'anime-cute-vector',
                name: 'cute-vector',
                value: 'cute-vector',
                img: 'cute-vector.png',
                buryName: 'Cute Vector',
            },
        ],
    },
    {
        categoryName: 'painting',
        list: [
            {
                uniqueKey: 'painting-color-sketch',
                name: 'color-sketch',
                value: 'color-sketch',
                img: 'color-sketch.png',
                buryName: 'Color Sketch',
            },
            {
                uniqueKey: 'painting-b&w-sketch',
                name: 'b&w-sketch',
                value: 'b&w-sketch',
                img: 'b&w-sketch.png',
                buryName: 'B&W Sketch',
                isPro: true,
            },
            {
                uniqueKey: 'painting-crayon',
                name: 'crayon',
                value: 'crayon',
                img: 'crayon.png',
                buryName: 'Crayon',
                isPro: true,
            },
            {
                uniqueKey: 'painting-artsy',
                name: 'artsy',
                value: 'artsy',
                img: 'artsy.png',
                buryName: 'Artsy',
            },

            {
                uniqueKey: 'painting-oil-painting',
                name: 'oil-painting',
                value: 'oil-painting-3',
                img: 'oil-painting-3.png',
                buryName: 'Oil Painting',
                isPro: true,
            },
            {
                uniqueKey: 'painting-picture-book-1',
                name: 'picture-book-1',
                value: 'picture-book',
                img: 'picture-book.png',
                buryName: 'Picture Book 01',
                isPro: true,
            },
            {
                uniqueKey: 'painting-picture-book-2',
                name: 'picture-book-2',
                value: "children's-picture-book",
                img: 'children-s-picture-book.png',
                buryName: 'Picture Book 02',
            },
            {
                uniqueKey: 'painting-picture-book-3',
                name: 'picture-book-3',
                value: 'picture-book-2',
                img: 'picture-book-2.png',
                buryName: 'Picture Book 3',
            },
            {
                uniqueKey: 'painting-watercolor-1',
                name: 'watercolor-1',
                value: 'watercolor',
                img: 'watercolor.png',
                buryName: 'Watercolor 1',
                isPro: true,
            },

            {
                uniqueKey: 'painting-brown-watercolor',
                name: 'brown-watercolor',
                value: 'brown-watercolor',
                img: 'brown-watercolor.png',
                buryName: 'Watercolor 2',
            },

            {
                uniqueKey: 'watercolor-3',
                name: 'watercolor-3',
                value: 'watercolor-1',
                img: 'watercolor-1.png',
                buryName: 'Watercolor 3',
            },

            {
                uniqueKey: 'painting-b&w-manga',
                name: 'b&w-manga',
                value: 'b&w-manga',
                img: 'b&w-manga.png',
                buryName: 'B&W Manga',
                isPro: true,
            },
            {
                uniqueKey: 'painting-pencil-sketch',
                name: 'pencil-sketch',
                value: 'pencil-sketch',
                img: 'pencil-sketch.png',
                buryName: 'Pencil Sketch',
            },
            {
                uniqueKey: 'painting-line-drawing',
                name: 'line-drawing',
                value: 'line-drawing',
                img: 'line-drawing.png',
                buryName: 'Line Drawing',
                isPro: true,
            },
            {
                uniqueKey: 'painting-manga-art',
                name: 'manga-art',
                value: 'manga-art',
                img: 'manga-art.png',
                buryName: 'Manga Art',
            },
            {
                uniqueKey: 'painting-pink-hand-drawn-art',
                name: 'pink-hand-drawn-art',
                value: 'pink-hand-drawn-art',
                img: 'pink-hand-drawn-art.png',
                buryName: 'Pink Sketch',
            },
            {
                uniqueKey: 'painting-chinese-ink',
                name: 'chinese-ink',
                value: 'chinese-ink',
                img: 'chinese-ink.png',
                buryName: 'Chinese Ink',
                isPro: true,
            },
            {
                uniqueKey: 'painting-van-gogh',
                name: 'van-gogh',
                value: 'van-gogh',
                img: 'van-gogh.png',
                buryName: 'Van Gogh',
                isPro: true,
            },
            {
                uniqueKey: 'painting-vibrant-fluid-portrait',
                name: 'vibrant-fluid-portrait',
                value: 'vibrant-fluid-portrait',
                img: 'vibrant-fluid-portrait.png',
                buryName: 'Fluid Portrait',
            },
        ],
    },
    {
        categoryName: '3d',
        list: [
            {
                uniqueKey: '3d-3d-polaroid',
                name: '3d-polaroid',
                value: '3d-polaroid',
                img: '3d-polaroid.png',
                buryName: '3D Polaroid',
                isPro: true,
            },

            {
                uniqueKey: '3d-3d-cartoon-1',
                name: '3d-cartoon-1',
                value: '3d-cartoon-1',
                img: '3d-cartoon-1.png',
                buryName: '3D Cartoon 1',
                isPro: true,
            },
            {
                uniqueKey: '3d-3d-cartoon-2',
                name: '3d-cartoon-2',
                value: '3d-cartoon-2',
                img: '3d-cartoon-2.png',
                buryName: '3D Cartoon 2',
                isPro: true,
            },
            {
                uniqueKey: '3d-3d-cartoon-3',
                name: '3d-cartoon-3',
                value: '3d-cartoon-3',
                img: '3d-cartoon-3.png',
                buryName: '3D Cartoon 3',
                isPro: true,
            },
            {
                uniqueKey: '3d-3d-emoji',
                name: '3d-emoji',
                value: '3d-emoji',
                img: '3d-emoji.png',
                buryName: '3D Emoji',
                isPro: true,
            },
            {
                uniqueKey: '3d-pastel-3d',
                name: 'blue-3d',
                value: 'blue-3d',
                img: 'pastel-3d.png',
                buryName: 'Pastel 3D',
            },
            {
                uniqueKey: '3d-fantasy-cgi',
                name: 'fantasy-cgi',
                value: 'fantasy-cgi',
                img: 'fantasy-cgi.png',
                buryName: 'Fantasy CGI',
            },
            {
                uniqueKey: '3d-pink-and-blue',
                name: '3d-pink-and-blue',
                value: '3d-pink-and-blue',
                img: '3d-pink-and-blue.png',
                buryName: 'Dreamy 3D',
            },
            {
                uniqueKey: '3d-tranquil-3d',
                name: 'tranquil-3d',
                value: 'tranquil-3d',
                img: 'tranquil-3d.png',
                buryName: '3D Cartoon',
            },
            {
                uniqueKey: '3d-orange',
                name: 'orange',
                value: 'orange',
                img: 'orange.png',
                buryName: 'Orange',
            },
        ],
    },
    {
        categoryName: 'action-figure',
        list: [
            {
                uniqueKey: 'action-figure-action-figure-1',
                name: 'action-figure-1',
                value: 'action-figure',
                img: 'action-figure.png',
                buryName: 'Action Figure 01',
                isPro: true,
            },

            {
                uniqueKey: 'action-figure-action-figure-2',
                name: 'action-figure-2',
                value: 'action-figure-2',
                img: 'action-figure-2.png',
                buryName: 'Action Figure 2',
            },
            {
                uniqueKey: 'action-figure-action-figure-3',
                name: 'action-figure-3',
                value: 'action-figure-3',
                img: 'action-figure-3.png',
                buryName: 'Action Figure 3',
                isPro: true,
            },
            {
                uniqueKey: 'action-figure-barbie',
                name: 'barbie',
                value: 'barbie',
                img: 'barbie.png',
                buryName: 'Barbie',
            },
            {
                uniqueKey: 'action-figure-pink',
                name: 'pink',
                value: 'pink',
                img: 'pink.png',
                buryName: 'Pink',
            },
            {
                uniqueKey: 'action-figure-baby',
                name: 'baby',
                value: 'baby',
                img: 'baby.png',
                buryName: 'Baby',
            },
        ],
    },
    {
        categoryName: 'stylize',
        list: [
            {
                uniqueKey: 'stylize-verdant-realism',
                name: 'verdant-realism',
                value: 'verdant-realism',
                img: 'verdant-realism.png',
                buryName: 'Realism',
            },
            {
                uniqueKey: 'stylize-y2k-aesthetic',
                name: 'y2k-aesthetic',
                value: 'y2k-aesthetic',
                img: 'y2k-aesthetic.png',
                buryName: 'Y2K Aesthetic',
                isPro: true,
            },
            {
                uniqueKey: 'stylize-pixel-art',
                name: 'pixel-art',
                value: 'pixel-art',
                img: 'pixel-art.png',
                buryName: 'Pixel Art',
                isPro: true,
            },
            {
                uniqueKey: 'stylize-toy-brick',
                name: 'toy-brick',
                value: 'toy-brick',
                img: 'toy-brick.png',
                buryName: 'Toy Brick',
                isPro: true,
            },
            {
                uniqueKey: 'stylize-bricks-puzzle',
                name: 'bricks-puzzle',
                value: 'bricks-puzzle',
                img: 'bricks-puzzle.png',
                buryName: 'Bricks Puzzle',
                isPro: true,
            },
            {
                uniqueKey: 'stylize-purple-art',
                name: 'purple-art',
                value: 'purple-art',
                img: 'purple-art.png',
                buryName: 'Purple Art',
            },
            {
                uniqueKey: 'stylize-cyberpunk-1',
                name: 'cyberpunk-1',
                value: 'cyberpunk',
                img: 'cyberpunk.png',
                buryName: 'Cyberpunk 1',
            },
            {
                uniqueKey: 'stylize-cyberpunk-2',
                name: 'cyberpunk-2',
                value: 'cyberpunk-2',
                img: 'cyberpunk-2.png',
                buryName: 'Cyberpunk 2',
                isPro: true,
            },
            {
                uniqueKey: 'stylize-horror-comics',
                name: 'horror-comics',
                value: 'horror-comics',
                img: 'horror-comics.png',
                buryName: 'Horror Comics',
            },
            {
                uniqueKey: 'stylize-pop-art',
                name: 'pop-art',
                value: 'pop-art',
                img: 'pop-art.png',
                buryName: 'Pop Art',
            },
            {
                uniqueKey: 'stylize-steampunk',
                name: 'steampunk',
                value: 'steampunk',
                img: 'steampunk.png',
                buryName: 'Steampunk',
                isPro: true,
            },
            {
                uniqueKey: 'stylize-gothic',
                name: 'gothic',
                value: 'gothic',
                img: 'gothic.png',
                buryName: 'Gothic',
                isPro: true,
            },
            {
                uniqueKey: 'stylize-metallic',
                name: 'metallic',
                value: 'metallic',
                img: 'metallic.png',
                buryName: 'Metallic',
            },
            {
                uniqueKey: 'stylize-golden-hour',
                name: 'golden-hour',
                value: 'golden-hour',
                img: 'golden-hour.png',
                buryName: 'Golden Hour',
            },
            {
                uniqueKey: 'stylize-dark-cyan',
                name: 'dark-cyan',
                value: 'dark-cyan',
                img: 'dark-cyan.png',
                buryName: 'Dark Cyan',
            },
            {
                uniqueKey: 'stylize-purple-glowing-illustration',
                name: 'purple-glowing-illustration',
                value: 'purple-glowing-illustration',
                img: 'purple-glowing-illustration.png',
                buryName: 'Glow Art',
            },
        ],
    },
    {
        categoryName: 'holiday',
        list: [
            {
                uniqueKey: 'holiday-christmas-1',
                name: 'christmas-1',
                value: 'christmas-1',
                img: 'christmas-1.png',
                buryName: 'Christmas 1',
            },
            {
                uniqueKey: 'holiday-christmas-2',
                name: 'christmas-2',
                value: 'christmas-2',
                img: 'christmas-2.png',
                buryName: 'Christmas 2',
            },
            {
                uniqueKey: 'holiday-christmas-3',
                name: 'christmas-3',
                value: 'christmas-3',
                img: 'christmas-3.png',
                buryName: 'Christmas 3',
            },
            {
                uniqueKey: 'holiday-christmas-4',
                name: 'christmas-4',
                value: 'christmas-4',
                img: 'christmas-4.png',
                buryName: 'Christmas 4',
            },
            {
                uniqueKey: 'holiday-halloween',
                name: 'halloween',
                value: 'halloween',
                img: 'halloween.png',
                buryName: 'Halloween',
            },
        ],
    },
];
// 删除模型后映射到已有模型
export const DELETE_STYLE_MAP = {
    'ghibli-3': 'ghibli-2',
    'red-toned-oil-painting': 'oil-painting-3',
    'oil-painting': 'oil-painting-3',
    'action-figure-1': 'action-figure',
    'ghibli-4': 'ghibli-2',
};
export const MAX_GENERATE_NUM = 4;
export const MOBILE_PREVIEW_DATA = [
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'dog.mp4?v=' + FJConfig.version,
        title: '图片1',
    },
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'people.mp4?v=' + FJConfig.version,
        title: '视频1',
    },
    {
        type: 'video',
        url: FJConfig.imgPath + 'mobileImgToImg/' + 'architecture.mp4?v=' + FJConfig.version,
        title: '图片2',
    },
];

export const IMAGE_NUMBER_LIST = [
    {
        value: 1,
        text: '1',
    },
    {
        value: 2,
        text: '2',
    },
    {
        value: 3,
        text: '3',
    },
    {
        value: 4,
        text: '4',
    },
];
